'use strict';

import React, { Component } from 'react';
import { GenericSelect, GenericSimpleButton, GenericOption } from 'com-gyf-webcore-userinterfacecomponents';

let PrincipalHeader = React.createClass({

    onChangeAdm: function (event) {
        let nro = event.target != undefined ? event.target.value : event;
        let lim = this.props.data.selectLimit;
        DistribucionLimitesActions.selectAdm(nro);
        switch (lim) {
            case 0:
                changeNameEnterprise(nro);
                break;
            case 1:
                changeNameCuentas(nro);
                break;
            case 2:
                changeNameCard(nro);
                break;
        }
    },

    onChangeLimit: function (event, id) {
        if (this.props.data.selectLimit != id) {
                this.props.changeLimite(id);
        }
    },

    render: function () {
        let me = this;
        let limitErrorEnterprise = this.props.isEditingData.limitErrorEnterprise != undefined ? this.props.isEditingData.limitErrorEnterprise : false
        let limitErrorCuentas = this.props.isEditingData.limitErrorCuentas != undefined ? this.props.isEditingData.limitErrorCuentas : false
        let limitErrorTarjetas = this.props.isEditingData.limitErroCards != undefined ? this.props.isEditingData.limitErroCards : false
        let imgErrorEnterprise = null;
        let imgErrorCuentas = null;
        let imgErrorTarjetas = null;
        let idAdm = this.props.data.selectAdm;
        let limiteSeleccionado = this.props.data.selectLimit;

        let oAdms = this.props.data.administradoras.map(function (adm) {
            if (adm.Id == idAdm) {
                return (<GenericOption id={adm.Id} description={adm.Descripcion} selected={"selected"} key={"AdmOp_" + adm.Id} />);
            }
            else {
                return (<GenericOption id={adm.Id} description={adm.Descripcion} key={"AdmOp_" + adm.Id} />);
            }
        });

        switch (limiteSeleccionado) {
            case 0:
                if (this.props.data.limiteEmpresaExcedido !== undefined && this.props.data.limiteEmpresaExcedido.excede) {
                    imgErrorEnterprise =
                        <div className="col-md-2">
                            <GenericSimpleButton text="Empresas" buttonClass="btn btn-cta" onClick={(event) => this.onChangeLimit(event, 0)} />
                            <span className="glyphicon glyphicon-exclamation-sign" style={{ "color": "red" }} aria-hidden="true"></span>
                        </div>
                }
                else {
                    imgErrorEnterprise = <div className="col-md-2">
                        <GenericSimpleButton text="Empresas" buttonClass="btn btn-cta" onClick={(event) => this.onChangeLimit(event, 0)} />
                    </div>
                }

                if (this.props.data.limiteCuentaExcedido !== undefined && this.props.data.limiteCuentaExcedido.excede) {
                    imgErrorCuentas =
                        <div className="col-md-2">
                            <GenericSimpleButton text="Cuentas" buttonClass="btn btn-secondary" onClick={(event) => this.onChangeLimit(event, 1)} />
                            <span className="glyphicon glyphicon-exclamation-sign" style={{ "color": "red" }} aria-hidden="true"></span>
                        </div>
                }
                else {
                    imgErrorCuentas = <div className="col-md-2">
                        <GenericSimpleButton text="Cuentas" buttonClass="btn btn-secondary" onClick={(event) => this.onChangeLimit(event, 1)} />
                    </div>
                }

                if (this.props.data.limiteTarjetasExcedido !== undefined && this.props.data.limiteTarjetasExcedido.excede) {
                    imgErrorTarjetas =
                        <div className="col-md-2">
                            <GenericSimpleButton text="Tarjetas" buttonClass="btn btn-secondary" onClick={(event) => this.onChangeLimit(event, 2)} />
                            <span className="glyphicon glyphicon-exclamation-sign" style={{ "color": "red" }} aria-hidden="true"></span>
                        </div>
                }
                else {
                    imgErrorTarjetas = <div className="col-md-2">
                        <GenericSimpleButton text="Tarjetas" buttonClass="btn btn-secondary" onClick={(event) => this.onChangeLimit(event, 2)} />
                    </div>
                }
                break;
            case 1:
                if (this.props.data.limiteEmpresaExcedido !== undefined && this.props.data.limiteEmpresaExcedido.excede) {
                    imgErrorEnterprise =
                        <div className="col-md-2">
                            <GenericSimpleButton text="Empresas" buttonClass="btn btn-secondary" onClick={(event) => this.onChangeLimit(event, 0)} />
                            <span className="glyphicon glyphicon-exclamation-sign" style={{ "color": "red" }} aria-hidden="true"></span>
                        </div>
                }
                else {
                    imgErrorEnterprise = <div className="col-md-2">
                        <GenericSimpleButton text="Empresas" buttonClass="btn btn-secondary" onClick={(event) => this.onChangeLimit(event, 0)} />
                    </div>
                }

                if (this.props.data.limiteCuentaExcedido !== undefined && this.props.data.limiteCuentaExcedido.excede) {
                    imgErrorCuentas =
                        <div className="col-md-2">
                            <GenericSimpleButton text="Cuentas" buttonClass="btn btn-cta" onClick={(event) => this.onChangeLimit(event, 1)} />
                            <span className="glyphicon glyphicon-exclamation-sign" style={{ "color": "red" }} aria-hidden="true"></span>
                        </div>
                }
                else {
                    imgErrorCuentas = <div className="col-md-2">
                        <GenericSimpleButton text="Cuentas" buttonClass="btn btn-cta" onClick={(event) => this.onChangeLimit(event, 1)} />
                    </div>
                }

                if (this.props.data.limiteTarjetasExcedido !== undefined && this.props.data.limiteTarjetasExcedido.excede) {
                    imgErrorTarjetas =
                        <div className="col-md-2">
                            <GenericSimpleButton text="Tarjetas" buttonClass="btn btn-secondary" onClick={(event) => this.onChangeLimit(event, 2)} />
                            <span className="glyphicon glyphicon-exclamation-sign" style={{ "color": "red" }} aria-hidden="true"></span>
                        </div>
                }
                else {
                    imgErrorTarjetas = <div className="col-md-2">
                        <GenericSimpleButton text="Tarjetas" buttonClass="btn btn-secondary" onClick={(event) => this.onChangeLimit(event, 2)} />
                    </div>
                }
                break;
            case 2:
                if (this.props.data.limiteEmpresaExcedido !== undefined && this.props.data.limiteEmpresaExcedido.excede) {
                    imgErrorEnterprise =
                        <div className="col-md-2">
                            <GenericSimpleButton text="Empresas" buttonClass="btn btn-secondary" onClick={(event) => this.onChangeLimit(event, 0)} />
                            <span className="glyphicon glyphicon-exclamation-sign" style={{ "color": "red" }} aria-hidden="true"></span>
                        </div>
                }
                else {
                    imgErrorEnterprise = <div className="col-md-2">
                        <GenericSimpleButton text="Empresas" buttonClass="btn btn-secondary" onClick={(event) => this.onChangeLimit(event, 0)} />
                    </div>
                }

                if (this.props.data.limiteCuentaExcedido !== undefined && this.props.data.limiteCuentaExcedido.excede) {
                    imgErrorCuentas =
                        <div className="col-md-2">
                            <GenericSimpleButton text="Cuentas" buttonClass="btn btn-secondary" onClick={(event) => this.onChangeLimit(event, 1)} />
                            <span className="glyphicon glyphicon-exclamation-sign" style={{ "color": "red" }} aria-hidden="true"></span>
                        </div>
                }
                else {
                    imgErrorCuentas = <div className="col-md-2">
                        <GenericSimpleButton text="Cuentas" buttonClass="btn btn-secondary" onClick={(event) => this.onChangeLimit(event, 1)} />
                    </div>
                }

                if (this.props.data.limiteTarjetasExcedido !== undefined && this.props.data.limiteTarjetasExcedido.excede) {
                    imgErrorTarjetas =
                        <div className="col-md-2">
                            <GenericSimpleButton text="Tarjetas" buttonClass="btn btn-cta" onClick={(event) => this.onChangeLimit(event, 2)} />
                            <span className="glyphicon glyphicon-exclamation-sign" style={{ "color": "red" }} aria-hidden="true"></span>
                        </div>
                }
                else {
                    imgErrorTarjetas = <div className="col-md-2">
                        <GenericSimpleButton text="Tarjetas" buttonClass="btn btn-cta" onClick={(event) => this.onChangeLimit(event, 2)} />
                    </div>
                }
                break;
        }

        return (
            <div className="row bottom-separator-xxs">
                <div className="col-md-3">
                    <label className="label-primary">Distribuir límites de</label>
                </div>
                <div className="col-md-2" >
                    <GenericSelect id="selAdms" className="form-control default-select bottom-separator-xs error" options={oAdms} onChange={this.onChangeAdm} />
                </div>
                <div className="col-md-1">
                    <label className="label-primary">entre</label>
                </div>
                {imgErrorEnterprise}
                {imgErrorCuentas}
                {imgErrorTarjetas}
            </div>
        );
    },
});

export default PrincipalHeader